import axios from "axios";
import { store } from "../redux/store";
import { logOut, updateUserToken } from "../redux/actions/userDataActions";
import apiClient, { sdkApiClient } from "./axios";

let apiUrl = process.env.REACT_APP_ADMIN_API_URL;
let userBackendUrl = process.env.REACT_APP_USER_BACKEND_URL;
let apiSdkUrl = process.env.REACT_APP_SDK_API_URL;
let sdkModelApiKey = process.env.REACT_APP_SDK_MODEL_API_KEY;

function userToken() {
  const state = store.getState();
  let token = state.userData.userToken;
  return token;
}

export async function login(data) {
  let config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("auth/login", config);
}

export async function logout() {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("auth/logout", config);
}

export async function restaurantList(filter) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant" + filter, config);
}

export async function getRestaurantCategoryList(type) {
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  if (type === "all") {
    return callApi("restaurant/category/all", config);
  }
}

export async function deleteRestaurantCategory(id) {
  const config = { method: "DELETE" };
  return callApi("restaurant/category/" + id, config);
}

export async function createRestaurantCategory(data) {
  const config = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  };

  return callApi("restaurant/category", config);
}

export async function updateRestaurantCategory(data) {
  const config = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  };
  return callApi("restaurant/category/" + data._id, config);
}

export async function uploadImageFile(data) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("files/upload-image", config);
}

export async function addRestaurant(data) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("restaurant", config);
}

export async function addRestaurantMenuCategory(data) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": data?._idRestaurant,   
    },
    data: data,
  };

  return callApi("menu/category", config);
}

export async function addRestaurantMenuItem(data) {
  const config = {
    method: "POST",
    headers: { "Restaurant-ID": store.getState().userData.restaurantData?._id, },
    data: data,
  };

  return callApi("menu", config);
}

export async function eventCategoryList(filter) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("event/category" + filter, config);
}

export async function createEvent(data) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("event", config);
}

export async function getEventList(filter) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("event" + filter, config);
}

export async function getRestaurantData(restaurantId) {
  const config = {
    method: "GET",
    headers: { "Restaurant-ID": restaurantId },
  };
  return callApi("restaurant/" + restaurantId, config);
}

export async function updateRestaurant(data, restaurantId) {
  const config = {
    method: "PUT",
    data: data,
  };
  return callApi("restaurant/" + restaurantId, config);
}

export async function getMenuCategoryList(filter, restaurantId) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi("menu/category?" + filter, config);
}

export async function getMenuList(filter, restaurantId) {
  const config = {
    method: "GET",
    headers: { "Restaurant-ID": restaurantId, },
  };

  return callApi("menu" + filter, config);
}

export async function addMenuCategory(data, restaurantId) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: data,
  };

  return callApi("menu/category", config);
}

export async function updateMenuCategory(data, catId, restaurantId) {
  let token = userToken();
  let config = {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
       "Restaurant-ID": restaurantId,
    },
    data: data,
  }
  return callApi("menu/category/" + catId, config);
}

export async function addMenu(data) {
  const config = {
    method: "POST",
    headers: { "Restaurant-ID": store.getState().userData.restaurantData?._id, },
    data: data,
  };

  return callApi("menu", config);
}

export async function updateMenu(data, itemId, restaurantId) {
  const config = {
    method: "PUT",
    headers: {
      "Restaurant-ID":
        restaurantId || store.getState().userData.restaurantData?._id,
    },
    data: data,
  };

  return callApi("menu/" + itemId, config);
}

export async function deleteMenu(itemId) {
  const config = {
    method: "DELETE",
    headers: { "Restaurant-ID": store.getState().userData.restaurantData?._id, },
  };

  return callApi("menu/" + itemId, config);
}

export async function menuRearrange(data) {
  let token = userToken();
  let config = {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": store.getState().userData.restaurantData?._id,
    },
    data: data,
  };

  return callApi("menu/rearrange", config);
}

export async function getMyEventList(filter) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("event" + filter, config);
}

export async function getCategoryData(restaurantId, catId) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi("menu/category/" + catId, config);
}

export async function getMenuData(itemId, restaurantId) {
  const config = {
    method: "GET",
    headers: {
      "Restaurant-ID":
        restaurantId || store.getState().userData.restaurantData?._id,
    },
  };

  return callApi("menu/" + itemId, config);
}

export async function getArModelData(modelId) {
  let config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
  };

  return callSdkApi("model/" + modelId, config);
}

export async function createArModel(data) {
  let config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
    data: data,
  };

  return callSdkApi("model", config);
}

export async function uploadArModel(data, id) {
  let config = {
    method: "PUT",
    headers: {
      "Content-Type": "multipart/form-data",
      "X-Api-Key": sdkModelApiKey,
    },
    data: data,
  };

  return callSdkApi("model/" + id + "/update/glb", config);
}

export async function updateArModelAttribute(data, id) {
  let config = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
    data: data,
  };

  return callSdkApi("model/" + id + "/update_attributes", config);
}

export async function deleteArModel(modelId) {
  let config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
  };

  return callSdkApi("model/" + modelId, config);
}

/**
 * 3D Model Images API (SDK) — input photos attached to a model.
 * See ar-models-implementation.md. All three operate on the model's `images`
 * collection and return the FULL current list ({ success, data: { rows, count } }).
 */

// Upload N photos. Multipart, field name "images" repeated once per file.
// Append-only: uploading again adds to the existing photos (does not replace).
export async function uploadModelImages(modelId, files) {
  const formData = new FormData();
  (files || []).forEach((file) => formData.append("images", file));

  let config = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      "X-Api-Key": sdkModelApiKey,
    },
    data: formData,
  };

  return callSdkApi("model/" + modelId + "/images", config);
}

// List the current photos for a model.
export async function getModelImages(modelId) {
  let config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
  };

  return callSdkApi("model/" + modelId + "/images", config);
}

// Delete one photo by its _id. Response carries the remaining photos.
export async function deleteModelImage(modelId, imageId) {
  let config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sdkModelApiKey,
    },
  };

  return callSdkApi("model/" + modelId + "/images/" + imageId, config);
}

export async function getOrders(filter, restaurantId) {
  const token = userToken();
  const config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  if (restaurantId) {
    config.headers["Restaurant-ID"] = restaurantId;
  }

  return callApi("orders?" + filter, config);
}

export async function getOrderByRef(ref) {
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return callApi("orders/ref/" + ref, config);
}

export async function createUpdateRestaurantStaff(
  restaurantId,
  staffData,
  staffId
) {
  const config = {
    method: staffId ? "PUT" : "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: staffData,
  };

  if (staffId) {
    return callApi("restaurant-user/" + staffId, config);
  } else {
    return callApi("restaurant-user/", config);
  }
}

export async function getUserRolesList(restaurantId, uToken) {
  let token = uToken ? uToken : userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-user-roles", config);
}

export async function deleteUserRole(userRoleId, restaurantId) {
  const config = {
    method: "DELETE",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-user/" + userRoleId, config);
}

export async function createUpdateUserRoles(
  data,
  userRoleId,
  restaurantId
) {
  const config = {
    method: userRoleId ? "PUT" : "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (userRoleId) {
    return callApi("restaurant-user-roles/" + userRoleId, config);
  } else {
    return callApi("restaurant-user-roles", config);
  }
}



export async function getGiftCardTemplate(filter, restaurantId) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi("gift-card-template" + filter, config);
}

export async function addUpdateGiftCardTemplate(
  data,
  restaurantId,
  templateId
) {
  let token = userToken();
  let config = {
    method: templateId ? "PUT" : "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: data,
  };

  if (templateId) {
    return callApi("gift-card-template/" + templateId, config);
  } else {
    return callApi("gift-card-template", config);
  }
}

export async function deleteGiftCardTemplate(restaurantId, templateId) {
  let token = userToken();
  let config = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi("gift-card-template/" + templateId, config);
}

export async function getUserList(filter) {
  let token = userToken();
  let config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("user" + filter, config);
}

export async function importFromUberEatsSwiggy(
  data,
  restaurantId,
  type,
  currency
) {
  let token = userToken();
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi(
    "menu/" + restaurantId + "/import/" + type + "?currency=" + currency,
    config
  );
}

export async function exportFoodoMenuJson(restaurantId) {
  let config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return callApi(`menu/${restaurantId}/export/foodo`, config);
}

export async function importFoodoMenuJson(restaurantId, data) {
  let config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  return callApi(`menu/${restaurantId}/import/foodo`, config);
}

export async function deleteRestaurant(resId) {
  let token = userToken();
  let config = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant/" + resId, config);
}

export async function deleteMenuCategory(restaurantId, catId) {
  let token = userToken();
  let config = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi("menu/category/" + catId, config);
}

export async function menuModelRearrange(data, restaurantId) {
  let token = userToken();
  let config = {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: data,
  };

  return callApi("menu/rearrange_model", config);
}

export async function categoryRearrange(data, restaurantId) {
  let token = userToken();
  let config = {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: data,
  };

  return callApi("menu/category/rearrange", config);
}

export async function addUpdateUser(data, id) {
  const token = userToken();
  const config = {
    method: id ? "PUT" : "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (id) {
    return callApi("user/" + id, config);
  } else {
    return callApi("user", config);
  }
}
export async function deleteUser(userId) {
  const config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi(`user/${userId}`, config);
}

export async function getFeaturesList() {
  const token = userToken();
  const config = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi("feature-flags", config);
}

export async function addFeatureToRestaurant(restaurantId, featureList) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: {
      featureIds: featureList,
    },
  };

  return callApi("feature-flags/add", config);
}

export async function removeFeatureFromRestaurant(restaurantId, featureList) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Restaurant-ID": restaurantId,
    },
    data: {
      featureIds: featureList,
    },
  };

  return callApi("feature-flags/remove", config);
}

export async function getAllPermissions() {
  const config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi("role/get-all-permissions", config);
}

export async function createRole(data) {
  const token = userToken();
  const config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    // data return type {"name": "Admin", "permissions": ["MANAGE_MENU", "DELETE_MENU"]}
    data: data,
  };

  return callApi("role", config);
}

export async function updateRole(roleId, data) {
  const token = userToken();
  const config = {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi(`role/${roleId}`, config);
}

export async function deleteRole(roleId) {
  const token = userToken();
  const config = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  return callApi(`role/${roleId}`, config);
}

export async function getAllRoles() {
  const config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi("role/all", config);
}

export async function getAllFeatureGroups() {
  const config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi("feature-flags-group", config);
}

export async function createFeatureGroup(newGroup) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: newGroup,
  };

  return callApi("feature-flags-group", config);
}

export async function updateFeatureGroup(group) {
  const config = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: group,
  };

  return callApi(`feature-flags-group/${group._id}`, config);
}

export async function deleteFeatureGroup(groupID) {
  const config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi(`feature-flags-group/${groupID}`, config);
}

export async function getAllFeatures() {
  const config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi("feature-flags", config);
}

export async function createFeature(newFeature) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: newFeature,
  };

  return callApi("feature-flags", config);
}

export async function updateFeature(feature) {
  const config = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: feature,
  };

  return callApi(`feature-flags/${feature._id}`, config);
}

export async function deleteFeature(featureID) {
  const config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi(`feature-flags/${featureID}`, config);
}

export async function getCategoryList(restaurantId, filter) {
  let config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  if (filter == "all") {
    return callApi("menu/category/all", config);
  } else {
    return callApi("menu/category?" + filter, config);
  }
}

export async function getCourseList(restaurantId, filter) {
  let config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-course" + filter, config);
}

export async function addUpdateCourse(data, restaurantId, courseId) {
  let config = {
    method: courseId ? "PUT" : "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (courseId) {
    return callApi("restaurant-course/" + courseId, config);
  } else {
    return callApi("restaurant-course", config);
  }
}

export async function deleteCourse(restaurantId, courseId) {
  let config = {
    method: "DELETE",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-course/" + courseId, config);
}

export async function courseRearrange(data, restaurantId) {
  let config = {
    method: "PUT",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("restaurant-course/rearrange", config);
}

export async function getMenuModifier(filter, restaurantId) {
  let config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi(`menu_modifier${filter}`, config);
}

export async function createMenuModifier(restaurantId, data) {
  console.log(restaurantId, "restaurantId");
  let config = {
    method: "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("menu_modifier", config);
}

export async function updateMenuModifier(restaurantId, data, id) {
  let config = {
    method: "PUT",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("menu_modifier/" + id, config);
}

export async function deleteMenuModifier(restaurantId, id) {
  let config = {
    method: "DELETE",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("menu_modifier/" + id, config);
}

export async function linkMenuModifier(restaurantId, data) {
  let config = {
    method: "PUT",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("menu_modifier/link", config);
}

export async function unlinkMenuModifier(restaurantId, data) {
  let config = {
    method: "PUT",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("menu_modifier/unlink", config);
}

export async function getMenuListModifiers(restaurantId, filter) {
  const config = {
    method: "GET",
    headers: { "Restaurant-ID": restaurantId },
  };

  return callApi("menu" + filter, config);
}

export async function getRestaurantPrinters(restaurantId) {
  const config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-printer", config);
}

export async function addOrUpdateRestaurantPrinter(restaurantId, printerData, printerId = null) {
  const config = {
    method: printerId ? "PUT" : "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: printerData,
  };

  if (printerId) return callApi("restaurant-printer/" + printerId, config);
  else return callApi("restaurant-printer", config);
}

export async function deleteRestaurantPrinters(restaurantId, printerId) {
  const config = {
    method: "DELETE",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-printer/" + printerId, config);
}

export async function getRestaurantFloors(restaurantId) {
  const config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };

  return callApi("restaurant-floors", config);
}

// Create Menu Translation API
export async function createMenuTranslation(restaurantId, menuItemId, data) {
  const config = {
    method: "POST",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return callApi(`translation/menu/${menuItemId}`, config);
}

// Get Menu Translations API
export async function getMenuTranslations(restaurantId, menuItemId, lang) {
  const config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
      "Content-Type": "application/json",
    },
  };
  return callApi(`translation/menu/${menuItemId}/translations?lang=${lang}`, config);
}

// Get Supported Languages API
export function getSupportedLanguages() {
  return [
    { code: "en", name: "English", nativeName: "English" },
    { code: "fr", name: "French", nativeName: "Français" },
    { code: "es", name: "Spanish", nativeName: "Español" },
    { code: "zh", name: "Chinese", nativeName: "中文" },
    { code: "ar", name: "Arabic", nativeName: "العربية" }
  ];
}

// Ui config apis 
export async function createMenuUiLayoutConfig(data) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi("menu-layout", config);
}

export async function updateMenuUiLayoutConfig(id, data) {
  const config = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return callApi(`menu-layout/${id}`, config);
}

export async function deleteMenuUiLayoutConfig(id) {
  const config = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return callApi(`menu-layout/${id}`, config);
}

// Get list of menu layouts. Optional `filter` should be a query string (e.g. "page=1&limit=10").
export async function getMenuUiLayoutConfigs() {
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  
  return callApi(`menu-layout`, config);
}

// Countries API
export async function getAllActiveCountries() {
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return callApi("countries/all", config);
}

export async function getCountryById(id) {
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return callApi(`countries/${id}`, config);
}

export async function getCountries(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const endpoint = queryString ? `countries?${queryString}` : "countries";
  
  const config = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return callApi(endpoint, config);
}


/**
 * Private functions
 */
async function callApi(endpoint, config) {
  const url = `${apiUrl}${endpoint}`;

  console.log("Url: ", url);
  console.log("Config: ", config);

  return apiClient({
    ...config,
    url: url,
  })
    .then((response) => {
      console.log("-----API RESPONSE-----", response.data);
      return response.data;
    })
    .catch(async function (error) {
      console.log(
        "There has been a problem with your fetch operation: " + error.message
      );

      if (typeof error.response !== "undefined") {
        if (typeof error.response.data !== "undefined") {
          if (error.response.data.data === "TokenExpiredError") {
            //refresh token
            return await refreshToken(endpoint, config);
          } else if (error.response.data.data === "JsonWebTokenError") {
            console.log("logout");
            await store.dispatch(logOut(""));
          } else if (
            error.response.data.code == 500 &&
            error.response.data.msg === "jwt expired"
          ) {
            console.log("logout");
            await store.dispatch(logOut(""));
          } else {
            return {
              success: false,
              msg: error.response.data.msg,
            };
          }
        }
      }
      return {
        success: false,
        msg: "Api Error",
      };
    });
}

async function callSdkApi(endpoint, config) {
  const url = `${apiSdkUrl}${endpoint}`;

  console.log("Url: ", url);
  console.log("Config: ", config);

  return sdkApiClient({
    ...config,
    url: url,
  })
    .then((response) => {
      console.log("-----API RESPONSE-----", response.data);
      return response.data;
    })
    .catch(async function (error) {
      console.log(
        "There has been a problem with your fetch operation: " + error.message
      );
      if (typeof error.response !== "undefined") {
        if (typeof error.response.data !== "undefined") {
          if (error.response.data.data === "TokenExpiredError") {
            //refresh token
            return await refreshToken(endpoint, config);
          } else if (error.response.data.data === "JsonWebTokenError") {
            console.log("logout");
            await store.dispatch(logOut(""));
          } else {
            return {
              success: false,
              msg: error.response.data.msg,
            };
          }
        }
      }
      return {
        success: false,
        msg: "Api Error",
      };
    });
}

async function refreshToken(endpoint1, config1) {
  const state = store.getState();
  let token = state.userData.refreshToken;
  let config = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };
  const url = `${apiUrl}auth/refresh`;
  return await axios({
    ...config,
    url: url,
  })
    .then(async (response) => {
      console.log("-----API RESPONSE-----", response.data);
      await store.dispatch(updateUserToken(response.data.data.token));
      config1["headers"] = {
        ...config1["headers"],
        Authorization: "Bearer " + response.data.data.token,
      };
      return await callApi(endpoint1, config1);
    })
    .catch(async function (error) {
      console.log(
        "There has been a problem with your fetch operation: " + error.message
      );
      console.log("logout");
      await store.dispatch(logOut(""));
      if (typeof error.response !== "undefined") {
        if (typeof error.response.data !== "undefined") {
          return {
            success: false,
            msg: error.response.data.msg,
          };
        }
      }
      return {
        success: false,
        msg: "Api Error",
      };
    });
}

// Whitelist Domain API
export async function whitelistDomain({domain, accountId}) {
  let config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      domain,
      accountId,
    },
    url: `${userBackendUrl}/stripe/whitelist-domain`,
  };
  return axios(config).then((response) => response.data);
}

// Get Restaurant Table List API
export async function getRestaurantTableList(filter, restaurantId) {
  let config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
    },
    url: userBackendUrl + "table" + filter,
  };
  return apiClient(config).then((response) => response.data);
}

// Table Booking Restaurant Settings API
export async function createTableBookingRestaurantSettings(data) {
  // Extract _id_restaurant for header and remove it from data
  const { _id_restaurant, ...dataWithoutId } = data;
  
  let config = {
    method: "PUT",
    headers: {
      "Restaurant-ID": _id_restaurant,
    },
    data: dataWithoutId,
  };

  return callApi("tb/restaurant-settings", config);
}

// Get Table Booking Restaurant Settings API
export async function getTableBookingRestaurantSettings(restaurantId) {
  let config = {
    method: "GET",
    headers: {
      "Restaurant-ID": restaurantId,
    },
  };

  return callApi(`tb/restaurant-settings`, config);
}

// ─── Subscription Catalogue (Admin) ─────────────────────────────────────────

export async function listSubscriptionProducts() {
  let token = userToken();
  let config = {
    method: 'GET',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
  };
  return callApi('products/all', config);
}

export async function createSubscriptionProduct(data) {
  let token = userToken();
  let config = {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
    data,
  };
  return callApi('products', config);
}

export async function updateSubscriptionProduct(key, data) {
  let token = userToken();
  let config = {
    method: 'PUT',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
    data,
  };
  return callApi(`products/${key}`, config);
}

export async function patchSubscriptionProductStatus(key, status) {
  let token = userToken();
  let config = {
    method: 'PATCH',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
    data: { status },
  };
  return callApi(`products/${key}/status`, config);
}

export async function deleteSubscriptionProduct(key) {
  let token = userToken();
  let config = {
    method: 'DELETE',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
  };
  return callApi(`products/${key}`, config);
}

// ─── Per-venue Subscription Admin ───────────────────────────────────────────

export async function listVenueSubscriptions(restaurantId) {
  let token = userToken();
  let config = {
    method: 'GET',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json', 'Restaurant-ID': restaurantId },
  };
  return callApi(`restaurant-product-subscriptions/${restaurantId}`, config);
}

export async function grantVenueSubscription(restaurantId, data) {
  let token = userToken();
  let config = {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json', 'Restaurant-ID': restaurantId },
    data,
  };
  return callApi(`restaurant-product-subscriptions/${restaurantId}`, config);
}

export async function patchVenueSubscription(restaurantId, productKey, data) {
  let token = userToken();
  let config = {
    method: 'PATCH',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json', 'Restaurant-ID': restaurantId },
    data,
  };
  return callApi(`restaurant-product-subscriptions/${restaurantId}/${productKey}`, config);
}

export async function revokeVenueSubscription(restaurantId, productKey) {
  let token = userToken();
  let config = {
    method: 'DELETE',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json', 'Restaurant-ID': restaurantId },
  };
  return callApi(`restaurant-product-subscriptions/${restaurantId}/${productKey}`, config);
}
